export const tableHeader = ["テナント名", "グループ名", "機械番号", ""];
